module.exports = __webpack_public_path__ + "img/primary.008bf60e.png";